import { useAtom } from 'jotai';
import Icon, { IconName } from '~/components/ui/Icon';
import { useBranding } from '~/lib/branding';
import { authorizationPendingAtom, authorizedAtom } from './lib';

function Authorization({ children }: { children: React.ReactNode }) {
  const [isAuthorized] = useAtom(authorizedAtom);
  const [isAuthorizationPending] = useAtom(authorizationPendingAtom);
  const branding = useBranding();

  if (!isAuthorized || isAuthorizationPending) {
    return (
      <div className="flex items-center justify-center h-dvh">
        <Icon name={branding as IconName} className="size-[70px]" />
      </div>
    );
  }

  return children;
}

export default Authorization;
